import { useLocation, useNavigate } from 'react-router-dom';
import PopUps from '../../../components/PopUps';
import { useEffect, useRef, useState } from 'react';
import { devUrl, endpoints, getProgressBarData, POST, requestInfo } from '../../../services/modulesServices/userManagement.api';
import { getNextActions } from '../EstateManagement/EstateManagement.controller';
import { dropdownDataOptions } from '../Migration/Migration.controller';
import { check, cross } from '../../../utils/Logo';
import { convertDateToDDmmYYYY, decode, encode, getFirstErrorKey } from '../../../utils/utils';
import { useTranslation } from 'react-i18next';
import HeaderComponent from '../../../components/header/Header.component';
import Loading from '../../../components/portalComponents/Loading.component';
import GenericHeader from '../../../components/moduleCommonFormik/GenericHeader';
import { Card, Form } from 'react-bootstrap';
import SideCard from '../../../components/moduleCommonFormik/SideCardGenericComponent';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import Declaration from '../EstateManagement/Allotment/Declaration';
import GenericPopupModal from '../../../components/moduleCommonFormik/GenericModalPopup.component';
import { EsignModal } from '../../commonPages/EsignModal';
import ScrollToTop from '../../../components/ScrollToTop';
import { bankDetailsInitialValue, MORTGAGE_CLOSURE_STEPS_DETAILS, MORTGAGE_DECLARATION_LABEL, MORTGAGE_DETAILS_TABLE, MORTGAGE_CURRENT_MORTGAGE_DETAILS } from './Mortgage.const';
import GenericActionTable from '../../../components/moduleCommonFormik/GenericActionTable';
import _ from 'lodash';
import GenericButtons from '../../../components/UI components/Buttons/GenericButtons';
import GenericFormCard from '../../../components/moduleCommonFormik/GenericFormCard.component';
import { entityDocumentData } from '../EstateManagement/LeaseDeed/LeaseDeed.controller';
import { MORTGAGE_CLOSURE_VALIDATION } from '../../../utils/formikValidation/FormikValidation';
import StatusAlertPopup from '../../../components/moduleCommonFormik/StatusAlertPopup';
import PaymentSubmissionStatus from '../../technicalFlowScreen/technicalClearanceForm/TechnicalClearencePayment/PaymentSubmissionStatus';
import ProgressBar from '../../../components/moduleCommonFormik/ProgressBar';

const MortgageClosure = () => {
    const location = useLocation();
    let navigate = useNavigate();
    const { t } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    let userType = user?.type;
    const searchParams: any = new URLSearchParams(location.search);
    const userUuid = JSON.parse(localStorage.getItem('user') || '{}')?.uuid;
    const entityId = JSON.parse(localStorage.getItem('user') || '{}')?.entityId;
    const applicationNumber = decode(searchParams.get('applicationNumber'));
    const signedFileStoreId = decode(searchParams.get('signedFileStoreId'));
    const esignError = decodeURIComponent(searchParams.get('error') || '');
    const actInd = searchParams.get('activeIndex');
    let reVisit = useRef(searchParams.get('reVisit') === 'true');

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [hasValidAction, setHasValidAction] = useState<boolean>(true);
    const [visitedIndex, setVisitedIndex] = useState<number>(1);
    const [activeIndex, setActiveIndex] = useState<number>(1);
    const [tableRowData, setTableRowData] = useState([]);
    const [entityDetails, setEntityDetails] = useState<any>({});
    const [selectedMortgage, setSelectedMortgage] = useState<any>(null);
    const [isChecked, setIsChecked] = useState([false, false, false]);
    const [documents, setDocuments] = useState<any>([]);
    const [eSignedDocumentData, setESignedDocumentData] = useState<any>(null);
    const [fileStoreId, setFileStoreId] = useState<any>(null);
    const [esignModal, setEsignModal] = useState<boolean>(false);
    const [applicationNo, setApplicationNo] = useState<any>();
    const [bankMortgageDetails, setBankMortgageDetails] = useState<any[]>([]);
    const [mortgageSearchResponse, setMortgageSearchResponse] = useState<any>({});
    const [progressBarDetails, setProgressBarDetails] = useState<any>(null);
    const [applicationData, setApplicationData] = useState<any>({});

    const formik = useFormik<any>({
        initialValues: { isUpdatable: true, esignOption: 'DSC' },
        onSubmit: (value: any) => {},
        validationSchema: MORTGAGE_CLOSURE_VALIDATION[`page${activeIndex}`]
    });

    const { values, setValues, setFieldTouched, errors } = formik;

    useEffect(() => {
        if (!!applicationNumber) {
            getProgressBarData(applicationNumber)
                .then(res => {
                    setProgressBarDetails(res.data);
                    const status: any = res.data?.progressStatus?.find((item: any) => item.isCurrent === true);
                    const tempApplicationData = {
                        applicationNo: applicationNumber,
                        status: res.data?.currentStatus,
                        data: res.data?.auditTrails,
                        bpaData: '',
                        pendingWith: status?.actor || '-'
                    };
                    setApplicationData(tempApplicationData);
                })
                .catch(e => console.log(e));
        }

        if (userType !== 'ENTERPRISE') {
            window.location.href = '/goa-idc/access-restricted';
        }

        let tempRowdata: any;
        (async () => {
            try {
                setIsLoading(true);

                const { data: mortgageData } = await POST(endpoints.searchMortgage + `?statusList=OPEN&entityIds=${entityId}`, {
                    RequestInfo: requestInfo()
                });

                let status: any = '';
                let appliedMortgageTableData: any = [];

                if (mortgageData?.MortgageDetails?.length > 0) {
                    const applicationIds = mortgageData.MortgageDetails.map((item: any) => item.estateApplications.uuid);
                    const applicationIdsString = applicationIds.join(',');
                    const allotmentsData = await POST(endpoints.allotmentDetailsSearch + `?applicationIds=${applicationIdsString}`, {
                        RequestInfo: requestInfo()
                    });

                    const allotmentsMap = new Map();
                    allotmentsData?.data?.allotmentDetails?.forEach((allotment: any) => {
                        allotmentsMap.set(allotment.applicationId, {
                            allotmentDate: allotment.allotmentDate,
                            docReferenceId: allotment.documents[0]?.docReferenceId
                        });
                    });

                    tempRowdata = mortgageData?.MortgageDetails.map((item: any) => ({
                        id: item?.estateApplications?.applicationNo,
                        applicationNo: item?.estateApplications?.applicationNo,
                        applicationId: item?.estateApplications?.uuid,
                        plotNo: item?.estateApplications?.appliedPlotDetails?.plotNo,
                        plotId: item?.estateApplications?.appliedPlotDetails?.uuid,
                        estateName: item?.estateApplications?.appliedPlotDetails?.estateDetails?.estateName,
                        typeDisplayName: item?.typeDisplayName,
                        bankName: item?.bankMortgageDetails
                            ?.filter((bank: any) => bank?.status === 'CURRENT')
                            ?.map((bank: any) => bank?.bankName || '--')
                            ?.join(', '),
                        nocDate: allotmentsMap.get(item.estateApplications.uuid)?.allotmentDate || '--',
                        mortgageOrder: allotmentsMap.get(item.estateApplications.uuid)?.docReferenceId,
                        mortgageUuid: item?.uuid
                    }));

                    const currentBankDetails = await Promise.all(
                        mortgageData?.MortgageDetails.flatMap((item: any) =>
                            item?.bankMortgageDetails
                                ?.filter((bank: any) => bank.status === 'CURRENT')
                                .map(async (bank: any) => {
                                    return {
                                        ...bank,
                                        mortgageId: item?.uuid,
                                        nocDate: allotmentsMap.get(item.estateApplications.uuid)?.allotmentDate || '--',
                                        mortgageOrder: allotmentsMap.get(item.estateApplications.uuid)?.docReferenceId,
                                        applicationNo: item?.estateApplications?.applicationNo
                                    };
                                })
                        )
                    );
                    setBankMortgageDetails(currentBankDetails);
                }

                if (applicationNumber) {
                    if (actInd) {
                        setActiveIndex(+actInd);
                        setVisitedIndex(+actInd);
                    }
                    let applicationAccess;
                    applicationAccess = await POST(endpoints?.applicationAccess + `?businessid=${applicationNumber}`, { RequestInfo: requestInfo() });
                    if (!applicationAccess?.data.isAuthorized) {
                        window.location.href = '/goa-idc/access-restricted';
                    }

                    const { data: applicationSearchData } = await POST(endpoints.searchAllotment + `?applicationNos=${applicationNumber}`, { RequestInfo: requestInfo() });
                    setSelectedMortgage(applicationSearchData?.estateApplications[0].modificationDetails.requestDetails.uniqueIdentifier);

                    setFileStoreId(applicationSearchData?.estateApplications[0]?.signedConsolidatedDocRefId);

                    const mortgageClosureRequest = applicationSearchData?.estateApplications?.[0]?.modificationDetails?.requestDetails?.mortgageClosureRequests;

                    const selecetdMortgageObject = tempRowdata?.find((val: any) => val?.id === applicationSearchData?.estateApplications[0].modificationDetails.requestDetails.uniqueIdentifier);
                    const mortgageOrderDocRefId = [selecetdMortgageObject?.mortgageOrder];

                    const bankRefIds = mortgageClosureRequest?.flatMap((val: any) => {
                        return [val?.bankMortgageDetails?.bankRefId];
                    });

                    const noDuesCertificateList = mortgageClosureRequest?.map((val: any) => val?.document?.fileStoreId);

                    const docUuids = [...(mortgageOrderDocRefId ? mortgageOrderDocRefId : []), ...(bankRefIds ? bankRefIds : []), ...(noDuesCertificateList ? noDuesCertificateList : [])].join(',');
                    const documentLists = docUuids ? await entityDocumentData(docUuids) : [];
                    const updatedMortgageDetails = await Promise.all(
                        mortgageClosureRequest?.map(async (item: any) => {
                            return {
                                ...(item?.bankMortgageDetails ? item?.bankMortgageDetails : {}),
                                bankLetter: item?.bankMortgageDetails?.bankRefId && documentLists?.find((docs: any) => docs?.docReferenceId === item?.bankMortgageDetails?.bankRefId),
                                mortgageOrderLetter: selecetdMortgageObject?.mortgageOrder && documentLists?.find((docs: any) => docs?.docReferenceId === selecetdMortgageObject?.mortgageOrder),
                                noDueCertificate: item?.document?.fileStoreId && documentLists?.find((docs: any) => docs?.docReferenceId === item?.document?.fileStoreId),
                                closureDate: item?.closureDate
                            };
                        })
                    );

                    setMortgageSearchResponse(applicationSearchData?.estateApplications[0]);
                    status = applicationSearchData?.estateApplications[0]?.status;
                    appliedMortgageTableData = [
                        {
                            id: applicationSearchData?.estateApplications?.[0]?.modificationDetails.requestDetails.uniqueIdentifier,
                            applicationNo: applicationSearchData?.estateApplications?.[0]?.modificationDetails.requestDetails.uniqueIdentifier,
                            plotNo: applicationSearchData?.estateApplications?.[0]?.appliedPlotDetails.plotNo,
                            estateName: applicationSearchData?.estateApplications?.[0]?.appliedPlotDetails.estateDetails.estateName,
                            typeDisplayName: '--',
                            bankName: applicationSearchData?.estateApplications?.[0]?.modificationDetails?.requestDetails?.mortgageClosureRequests
                                ?.map((val: any) => val?.bankMortgageDetails?.bankName)
                                .join(', '),
                            nocDate: applicationSearchData?.estateApplications?.[0]?.modificationDetails?.requestDetails?.mortgageClosureRequests?.[0]?.bankMortgageDetails?.nocDate
                        }
                    ];

                    const nextActions = await getNextActions(applicationNumber);
                    setHasValidAction(nextActions?.nextValidAction?.length > 0);

                    setValues((prev: any) => ({
                        ...prev,
                        isUpdatable: nextActions?.nextValidAction?.length > 0 ? true : false,
                        currentMortgageDetails: updatedMortgageDetails,
                        plotId: applicationSearchData?.estateApplications?.[0]?.appliedPlotDetails?.uuid,
                        applicationId: applicationSearchData?.estateApplications?.[0]?.modificationDetails?.applicationId,
                        mortgageUuid: mortgageClosureRequest?.[0]?.mortgageUuid
                    }));
                }

                const rowData = status && status !== 'DRAFT' ? appliedMortgageTableData : tempRowdata;
                setTableRowData(rowData);

                const { data } = await POST(endpoints.searchExistingUser + `?tenantId=ga&userUuid=${userUuid}`, { RequestInfo: requestInfo() });
                setEntityDetails(data?.enterpriseEntity[0]);

                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();
    }, [location.search]);

    useEffect(() => {
        const fetchESignStatus = async () => {
            try {
                let payload = {
                    RequestInfo: requestInfo(),
                    applicationNumber: applicationNo || applicationNumber,
                    filestoreId: signedFileStoreId || undefined
                };

                const { data } = await POST(endpoints.consolidatedDocSearch, payload);
                data.filestoreId && setESignedDocumentData(data);
                !data.isEsignRequired && setIsChecked([true, true, true]);
            } catch (e: any) {
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        };
        if (activeIndex === 3 && (reVisit?.current ? reVisit.current : !signedFileStoreId)) {
            fetchESignStatus();
        }
    }, [activeIndex]);

    useEffect(() => {
        if (esignError && !signedFileStoreId) {
            setModalDetails({ show: true, title: 'Error!', para: esignError || 'eSign failed, please try again', img: cross, type: 'error', reUpload: 'OK' });
        }

        (async () => {
            try {
                let payload = {
                    RequestInfo: requestInfo(),
                    applicationNumber: applicationNo || applicationNumber,
                    filestoreId: signedFileStoreId || undefined
                };

                if (signedFileStoreId) {
                    const { data } = await POST(endpoints.consolidatedDocESign, payload);
                    // setESignedDocumentData(data);
                    const consolidatedDocSearch = await POST(endpoints.consolidatedDocSearch, payload);
                    consolidatedDocSearch?.data.filestoreId && setESignedDocumentData(consolidatedDocSearch?.data);
                    !data.isEsignRequired && setIsChecked([true, true, true]);
                }
            } catch (e: any) {
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        })();
    }, [signedFileStoreId]);

    const resetUrl = () => {
        let url = new URL(window.location.href);
        let searchParams = new URLSearchParams(url.search);
        reVisit.current = true;
        searchParams.set('reVisit', 'true');
        const newUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`;
        window.history.replaceState({}, document.title, newUrl);
    };

    const handleStepClick = async (index: number) => {
        if (!hasValidAction) {
            setActiveIndex(index);
        } else {
            if (index <= activeIndex) {
                setActiveIndex(index);
                if (index < 3 && activeIndex >= 3 && signedFileStoreId) {
                    resetUrl();
                }
                window.scrollTo(0, 0);
            } else {
                setModalDetails({
                    show: true,
                    title: t('ERROR', 'Error!'),
                    para: t('PLEASE_SAVE_THE_APPLICATION', 'Please save the application before proceeding'),
                    img: cross,
                    type: 'error',
                    reUpload: 'OK'
                });
            }
        }
    };

    const onChangePrevIndex = () => {
        const stepperLength = MORTGAGE_CLOSURE_STEPS_DETAILS.length;
        if (activeIndex <= stepperLength && activeIndex > 1) {
            setActiveIndex(activeIndex - 1);
            formik.setTouched({ back: true });
        }

        if (activeIndex <= 3 && signedFileStoreId) {
            resetUrl();
        }
    };

    const onMortgageSelect = async (selectedPlotApplication: any) => {
        setSelectedMortgage(selectedPlotApplication.id);
        const filteredMortgageDetails = bankMortgageDetails.filter(bank => bank.applicationNo === selectedPlotApplication.id);
        const docUuids = filteredMortgageDetails
            ?.flatMap((val: any) => {
                return [val?.bankRefId, val?.mortgageOrder];
            })
            .join(',');
        const documentLists = docUuids ? await entityDocumentData(docUuids) : [];
        const updatedMortgageDetails = await Promise.all(
            filteredMortgageDetails.map(async item => {
                return {
                    ...item,
                    bankLetter: item.bankRefId && documentLists?.find((docs: any) => docs?.docReferenceId === item.bankRefId),
                    mortgageOrderLetter: item.mortgageOrder && documentLists?.find((docs: any) => docs?.docReferenceId === item.mortgageOrder)
                };
            })
        );
        setValues((prev: any) => ({
            ...prev,
            currentMortgageDetails: updatedMortgageDetails,
            plotId: selectedPlotApplication?.plotId,
            applicationId: selectedPlotApplication?.applicationId,
            mortgageUuid: selectedPlotApplication.mortgageUuid
        }));
    };

    const mortgageDetailsTableColumns = MORTGAGE_DETAILS_TABLE.map((val: any, index: number) => {
        if (index === 0) {
            return {
                ...val,
                onRadioClick: onMortgageSelect,
                selectedValue: selectedMortgage
            };
        }
        return val;
    });

    const renderMortgageDetailsTable = () => {
        return (
            <>
                {!!applicationNumber && applicationData.status !== 'Draft' && (
                    <Card className='card_border my-2'>
                        <Card.Body>
                            <PaymentSubmissionStatus data={applicationData} children={<ProgressBar progressBarDetails={progressBarDetails} />} />
                        </Card.Body>
                    </Card>
                )}
                <Card className='card_border'>
                    <Card.Body>
                        <div className='ps-2 py-2 d-flex justify-content-between'>
                            <div className='formTitle m-0'>{'Mortgage Details'}</div>
                        </div>
                        <GenericActionTable rowData={tableRowData} columns={mortgageDetailsTableColumns} searchBarPlaceholder={'Search by Application Number...'} />
                    </Card.Body>
                </Card>
            </>
        );
    };

    const ClosureDetails = () => {
        return (
            <>
                {values?.currentMortgageDetails?.length > 0 && (
                    <Card className='card_border '>
                        <Card.Body>
                            <div className='formTitle m-0 p-3'>Current Mortgage Details</div>
                            <form>
                                <FieldArray name='currentMortgageDetails'>
                                    {({ insert, remove, push }) => (
                                        <div>
                                            {values.currentMortgageDetails.map((data: any, index_p: number) => (
                                                <div className='row' key={index_p}>
                                                    <div className='col-sm-12 align-items-center pb-2'>
                                                        <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                                        <div className='ps-1'>
                                                            {MORTGAGE_CURRENT_MORTGAGE_DETAILS.map((val: any, _: number) => (
                                                                <GenericFormCard fieldPath={`currentMortgageDetails.${index_p}`} {...val} />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </FieldArray>
                            </form>
                        </Card.Body>
                    </Card>
                )}
            </>
        );
    };

    const onChangeNextIndex = async () => {
        const stepperLength = MORTGAGE_CLOSURE_STEPS_DETAILS.length;
        try {
            setIsLoading(true);
            if (activeIndex < stepperLength) {
                setActiveIndex(activeIndex + 1);
            }
            if (visitedIndex < activeIndex + 1) setVisitedIndex(activeIndex + 1);
            window.scrollTo(0, 0);
            setIsLoading(false);
        } catch (e) {
            setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: t('FILL_ALL_REQUIRED_DETAILS', 'Please fill in all the required details!'), img: cross, type: 'error', reUpload: 'OK' });
            setIsLoading(false);
        }
    };

    const handleCheckboxChange = (i: any) => {
        let checks = isChecked;
        checks[i] = !isChecked[i];
        setIsChecked([...checks]);
    };

    const handleClickSignDocument = () => {
        if (activeIndex === 3 && !isChecked.every((e: boolean) => e)) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please accept all the terms', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }
        setEsignModal(true);
    };

    const onSubmit = async (isSaveOnly?: boolean, status?: any, comment?: string) => {
        const mortgageClosureRequests = values?.currentMortgageDetails?.map((val: any) => {
            return {
                bankMortgageDetails: { ...val },
                document: val?.noDueCertificate?.docReferenceId
                    ? { fileStoreId: val?.noDueCertificate?.docReferenceId, documentName: val?.noDueCertificate?.documentName, docReferenceId: val?.noDueCertificate?.docReferenceId }
                    : undefined,
                mortgageUuid: values?.mortgageUuid,
                closureDate: convertDateToDDmmYYYY(val?.closureDate)
            };
        });
        const payload = {
            RequestInfo: requestInfo(),
            ...(mortgageSearchResponse ? mortgageSearchResponse : {}),
            enterpriseEntity: entityDetails,
            applicationType: 'MORTGAGE_CLOSURE',
            appliedPlotId: values?.plotId,
            isFinalSubmit: activeIndex === 3,
            modificationDetails: {
                ...(mortgageSearchResponse?.modificationDetails ? mortgageSearchResponse?.modificationDetails : {}),
                applicationId: values?.applicationId,
                modificationType: 'MORTGAGE_CLOSURE',
                requestDetails: {
                    mortgageClosureRequests: mortgageClosureRequests,
                    uniqueIdentifier: selectedMortgage
                }
            }
        };

        if (activeIndex === 3 && eSignedDocumentData?.isEsignRequired) {
            setModalDetails({ show: true, title: 'E-Sign Pending', para: 'Please sign the document', img: cross, type: 'error', reUpload: 'OK' });
            return;
        }

        try {
            await MORTGAGE_CLOSURE_VALIDATION[`page${activeIndex}`].validate(values, { abortEarly: false, context: values });

            const endpoint = applicationNo || applicationNumber ? endpoints.updateAllotment : endpoints.createAllotment;
            try {
                setIsLoading(true);
                const { data: response } = await POST(endpoint, payload);
                setApplicationNo(response?.estateApplications[0]?.applicationNo);
                setMortgageSearchResponse(response?.estateApplications[0]);
                !isSaveOnly && onChangeNextIndex();
                activeIndex === 3 &&
                    setModalDetails({
                        show: true,
                        title: t('SUCCESS', 'Success!'),
                        para: t('APPLICATION_SUBMITTED_SUCCESSFULLY', 'Application submitted successfully'),
                        img: check,
                        type: 'success',
                        reUpload: 'OK',
                        isFinalSubmit: true
                    });
                setIsLoading(false);
            } catch (e: any) {
                let errMsg = e?.response?.data?.errorMessage || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setIsLoading(false);
                setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        } catch (validationError) {
            let errorField = getFirstErrorKey(errors);
            if (errorField) {
                const escapedErrorField = errorField.replace(/([[\].])/g, '\\$1');
                await setFieldTouched(errorField, true, true);
                let getErrorField: any = document.querySelector(`[name=${escapedErrorField}]`);
                getErrorField && getErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            setModalDetails({ show: true, title: 'Error!', para: t('ALL_REQUIRED_DETAILS', 'Please fill in all the required details!'), img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const signDocument = async () => {
        let url = window.location.origin + `/goa-idc/estate/mortgage-closure?activeIndex=${activeIndex}&applicationNumber=${applicationNo || applicationNumber}`;
        url = btoa(url);

        if (values.esignOption === 'EKYC') {
            const userRequestInfo = requestInfo();
            const eKYCInitiate =
                devUrl +
                endpoints.kycInitiate +
                `?fileStoreId=${eSignedDocumentData.filestoreId}&accessToken=${userRequestInfo.authToken}&userType=${userRequestInfo.userType}${
                    userRequestInfo.departmentCode ? `&departmentCode=${userRequestInfo.departmentCode}` : ''
                }&callBackUrl=${url}${values.esignUsername ? `&eSignUsername=${encode(values.esignUsername)}` : ''}`;

            window.open(eKYCInitiate, '_self');
        } else {
            navigate(`/goa-idc/emudra-esign?fileStoreId=${eSignedDocumentData.filestoreId}&callbackUrl=${url}`);
        }
    };

    const onChangeIndex = async () => {
        try {
            if (activeIndex < MORTGAGE_CLOSURE_STEPS_DETAILS.length) {
                setActiveIndex(activeIndex + 1);
            }
            window.scrollTo(0, 0);
        } catch (e) {
            setModalDetails({ show: true, title: 'Error!', para: 'Please fill in all the required details!', img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const onCancel = () => {
        navigate(-1);
    };

    const handleModalClose = () => {
        if (modalDetails?.type === 'success' && modalDetails?.isFinalSubmit) {
            navigate('/goa-idc/enterprisedashboard');
        }
        setModalDetails({ show: false });
    };

    console.log('formik', formik);

    return (
        <>
            <>
                <PopUps modalDetails={modalDetails} setModalDetails={setModalDetails} userType={userType} />
                <HeaderComponent />
                {isLoading ? (
                    <Loading />
                ) : (
                    <>
                        <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                            <GenericHeader
                                text={t('APPLICATION_FOR_MORTGAGE_CLOSURE', 'Application for Mortgage Closure')}
                                bottomSubText={(applicationNo || applicationNumber) && `Type : Mortgage Closure, No: ${applicationNo || applicationNumber}`}
                                additionalClass='sub-text-style'
                            />
                            <div className='col-3 stickyCard-section'>
                                <div className='stickyCard' style={{ top: '110px' }}>
                                    <GenericHeader
                                        text={t('APPLICATION_FOR_MORTGAGE_CLOSURE', 'Application for Mortgage Closure')}
                                        sideHeader={true}
                                        additionalClass='sub-text-style'
                                        bottomSubText={(applicationNo || applicationNumber) && `Type : Mortgage Closure, No: ${applicationNo || applicationNumber}`}
                                    />
                                    <Card className='card_border p-3'>
                                        <Card.Body>
                                            <Card.Text className=' d-flex flex-column  row-gap-3'>
                                                <SideCard
                                                    steps={MORTGAGE_CLOSURE_STEPS_DETAILS}
                                                    visitedIndex={visitedIndex}
                                                    activeIndex={activeIndex}
                                                    handleStepClick={handleStepClick}
                                                    indexType={'alphabets'}
                                                />
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                            <div className='col-9 form-section'>
                                <FormikProvider value={formik}>
                                    <Form>
                                        {activeIndex === 1 && renderMortgageDetailsTable()}
                                        {activeIndex === 2 && ClosureDetails()}

                                        {activeIndex === 3 && (
                                            <Declaration
                                                isChecked={isChecked}
                                                declarationList={MORTGAGE_DECLARATION_LABEL}
                                                handleCheckboxChange={(e: any) => handleCheckboxChange(e)}
                                                setDocuments={setDocuments}
                                                signDocument={handleClickSignDocument}
                                                eSignedDocumentData={eSignedDocumentData}
                                                applicantName={'Lessee'}
                                                fileStoreId={fileStoreId}
                                                isDisabled={!hasValidAction}
                                            ></Declaration>
                                        )}
                                    </Form>
                                    <GenericPopupModal
                                        title={t('SIGN_THE_DOCUMENT', 'Sign the document')}
                                        primaryBtnTitle={t('CONFIRM', 'Confirm')}
                                        secondaryBtnTitle={t('CLOSE', 'Close')}
                                        isSecondaryBtn={true}
                                        secondaryAction={() => {
                                            setEsignModal(false);
                                            setValues((prevVal: any) => ({ ...prevVal, esignOption: 'DSC', esignUsername: '' }));
                                        }}
                                        primaryAction={signDocument}
                                        isVisible={esignModal}
                                        children={<EsignModal />}
                                        isPrimaryDisabled={values?.esignOption === 'EKYC' && !values?.esignUsername}
                                    />
                                </FormikProvider>
                            </div>
                        </div>
                        <ScrollToTop />
                        <footer className='footer fixed-bottom footerBtnPatch'>
                            <div className='d-flex'>
                                <>
                                    <div className='d-flex justify-content-start  container me-3' style={{ padding: 15 }}>
                                        {activeIndex !== 1 && <GenericButtons text={t('PREVIOUS', 'Previous')} handleClick={onChangePrevIndex} />}
                                    </div>
                                    <div className='d-flex justify-content-end  container me-3' style={{ padding: 15 }}>
                                        {hasValidAction ? (
                                            <>
                                                {activeIndex !== MORTGAGE_CLOSURE_STEPS_DETAILS.length && activeIndex !== 4 && activeIndex !== 1 && (
                                                    <GenericButtons text={t('SAVE', 'Save')} handleClick={() => onSubmit(true)} ClassName='me-3' />
                                                )}
                                                <GenericButtons
                                                    text={activeIndex !== MORTGAGE_CLOSURE_STEPS_DETAILS.length ? `Save & Next` : t('SUBMIT', 'Submit')}
                                                    variant='primary'
                                                    handleClick={() => onSubmit()}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <>
                                                    {activeIndex === MORTGAGE_CLOSURE_STEPS_DETAILS.length ? (
                                                        <>
                                                            <GenericButtons text={t('CLOSE', 'Close')} variant='primary' handleClick={onCancel} />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <GenericButtons text={t('NEXT', 'Next')} variant='primary' handleClick={onChangeIndex} />
                                                        </>
                                                    )}
                                                </>
                                            </>
                                        )}
                                    </div>
                                </>
                            </div>
                        </footer>
                    </>
                )}
            </>
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose()}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose()}
            />
        </>
    );
};

export default MortgageClosure;
